import { PathOptions } from 'leaflet';
import { chakraTheme } from 'themes';
import { MandatoryMapComponentLayerStyles } from './MapContext/types';

export const DEFAULT_MAP_OPTIONS = {
  center: {
    lat: 38.32999644906359,
    lng: -100
  },
  zoom: 4.4,
  zoomSnap: 0.2,
  zoomControl: false,
  scrollWheelZoom: true,
  attributionControl: false
};

export const DEFAULT_MAP_STYLE = {
  height: '60vh',
  width: '100%',
  background: '#ddd',
  backgroundColor: chakraTheme.colors?.tableHeaderBlue
};

export const DEFAULT_HEATMAP_COLORS = [
  '#D6E6ED',
  '#B6DBE9',
  '#98D1E6',
  '#7AC7E2',
  '#5DBEDF',
  '#41B5DB',
  '#26ACD8',
  '#07A1D4',
  '#0192C3',
  '#0181AE',
  '#01739E',
  '#01658D',
  '#01567A',
  '#014667',
  '#013856'
];

// Default Layer Styles
const DEFAULT_STATE_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 0.8,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.explorerBackground,
  fillOpacity: 1
};

const DEFAULT_COUNTY_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 0.3,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.explorerBackground,
  fillOpacity: 1
};

const STATE_LAYER_STYLE_WHEN_COUNTY_LAYER_ACTIVE: PathOptions = {
  stroke: true,
  weight: 1,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: false,
  fillOpacity: 0
};

const SELECTED_COUNTY_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 2,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.explorerBackground,
  fillOpacity: 1
};

const SELECTED_STATE_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 2,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.explorerBackground,
  fillOpacity: 1
};

const NO_INFORMATION_STATE_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 0.8,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.greyDarkDisable,
  fillOpacity: 1
};

const NO_INFORMATION_COUNTY_LAYER_STYLE: PathOptions = {
  stroke: true,
  weight: 0.3,
  color: chakraTheme.colors?.darkBlue,
  opacity: 1,
  fill: true,
  fillColor: chakraTheme.colors?.greyDarkDisable,
  fillOpacity: 1
};

const DEFAULT_STATE_MARKER_STYLE = {
  w: '20px',
  textStyle: 'regular-12-14',
  color: chakraTheme.colors?.darkBlue
};

const SELECTED_STATE_MARKER_STYLE = {
  w: '20px',
  textStyle: 'semiBold-12-14',
  color: chakraTheme.colors?.white
};

const NO_INFORMATION_STATE_MARKER_STYLE = {
  w: '20px',
  textStyle: 'regular-12-14',
  color: chakraTheme.colors?.greyDarkDisable
};

export const DEFAULT_LAYER_STYLES: MandatoryMapComponentLayerStyles = {
  defaultStateLayerStyle: DEFAULT_STATE_LAYER_STYLE,
  defaultCountyLayerStyle: DEFAULT_COUNTY_LAYER_STYLE,
  stateLayerStyleWhenCountyLayerActive:
    STATE_LAYER_STYLE_WHEN_COUNTY_LAYER_ACTIVE,
  selectedCountyLayerStyle: SELECTED_COUNTY_LAYER_STYLE,
  selectedStateLayerStyle: SELECTED_STATE_LAYER_STYLE,
  noInformationStateLayerStyle: NO_INFORMATION_STATE_LAYER_STYLE,
  noInformationCountyLayerStyle: NO_INFORMATION_COUNTY_LAYER_STYLE,
  stateMarkerStyle: DEFAULT_STATE_MARKER_STYLE,
  selectedStateMarkerStyle: SELECTED_STATE_MARKER_STYLE,
  noInformationMarkerStyle: NO_INFORMATION_STATE_MARKER_STYLE
};

export const OVERRIDE_LEAFLET_STYLE = {
  '.leaflet-popup': {
    marginBottom: '0px',
    boxShadow: chakraTheme.shadow?.mediumShadow
  },
  '.leaflet-popup-content p': {
    margin: '0 0'
  },

  '.leaflet-popup-content-wrapper': {
    padding: '0px',
    borderRadius: '3px'
  },

  '.leaflet-popup-content': {
    margin: '0px 0px 0px 0px'
  },

  '.leaflet-container a.leaflet-popup-close-button': {
    display: 'none'
  },
  'g:focus': {
    outline: 'none'
  },
  'path:focus': {
    outline: 'none'
  }
};
